declare const window: ExtendedWindow & {
    sfccData: ExtendedWindow['sfccData'] & {
        serviceWorkerData: {
            siteContext: string;
        };
    };
};

/**
 * @description We need to normalize path because on dev - it would be /, but on
 * sandbox it usually /s/SiteId/
 * @param relativeUrl - relative url to service worker
 * @returns normalized url to service worker
 */
function normalizeUrl(relativeUrl: string): string {
    const sandboxUrlType = window.location.pathname.match(/(\/s\/[^/]+)\/?/);
    const siteContext = window.sfccData?.serviceWorkerData?.siteContext;

    let urlPrefix = '';

    if (sandboxUrlType) {
        urlPrefix = sandboxUrlType[1];
    } else if (siteContext) {
        urlPrefix = `/${siteContext}`;
    }

    return urlPrefix + relativeUrl;
}

export default function () {
    if ('serviceWorker' in navigator) {
        let serviceWorkerInstance;

        if (window.location.pathname.indexOf('on/demandware.store') > -1) {
            // Skip service worker registration for not user friendly URLs
            return;
        }

        navigator.serviceWorker
            .register(normalizeUrl('/service-worker.js'), { scope: '/' })
            .then(registration => {
                serviceWorkerInstance = registration;
            })
            .catch(() => {
                if (!serviceWorkerInstance) {
                    return;
                }

                serviceWorkerInstance.unregister().then(isUnregistered => {
                    if (isUnregistered) {
                        serviceWorkerInstance = null;
                    }
                });
            });
    }
}
